import { createContext, useContext, ReactNode } from 'react';
import { useMerchantSSE } from '../hooks/useMerchantSSE';

interface SSEContextType {
    isConnected: boolean;
    reconnect: () => void;
    disconnect: () => void;
}

const SSEContext = createContext<SSEContextType | undefined>(undefined);

export function SSEProvider({ children }: { children: ReactNode }) {
    // Initialize the SSE connection at the app root level
    const sse = useMerchantSSE({ enabled: true });

    return (
        <SSEContext.Provider value={sse}>
            {children}
        </SSEContext.Provider>
    );
}

export function useSSEContext() {
    const context = useContext(SSEContext);
    if (context === undefined) {
        throw new Error('useSSEContext must be used within an SSEProvider');
    }
    return context;
}
